import { render } from "./Home.vue?vue&type=template&id=44771b15&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=44771b15&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\Basseliersstraat\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__